'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SavedPaymentDetails = require('@quixeltools/quixel-ui-library/dist/components/common/checkout/SavedPaymentDetails');

var _SavedPaymentDetails2 = _interopRequireDefault(_SavedPaymentDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentMethod = function PaymentMethod(_ref) {
  var _ref$customer = _ref.customer,
      name = _ref$customer.name,
      company = _ref$customer.company,
      address1 = _ref$customer.address1,
      address2 = _ref$customer.address2,
      postalCode = _ref$customer.postalCode,
      country = _ref$customer.country,
      city = _ref$customer.city,
      state = _ref$customer.state,
      _ref$customer$payment = _ref$customer.paymentMethod,
      type = _ref$customer$payment.paymentMethodInstrument,
      last4 = _ref$customer$payment.last4,
      email = _ref$customer$payment.email,
      expirationDate = _ref$customer$payment.expirationDate;
  return _react2.default.createElement(_SavedPaymentDetails2.default, {
    billingDetails: {
      name: name,
      company: company,
      address: address1,
      address2: address2,
      city: city,
      state: state,
      postalCode: postalCode,
      country: country
    },

    paymentDetails: type === 'creditCard' ? { last4: last4, expirationDate: expirationDate } : { email: email },

    paymentLogosSrc: '/icons/payment-icons.png',
    braintreeLink: 'https://www.braintreegateway.com/merchants/2mgdr37qhn27xsmy/verified'
  });
};

exports.default = PaymentMethod;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentMethod/PaymentMethod.jsx
// module id = 2657
// module chunks = 0